import WebApiService from '../services/WebApiService';

export default class GoalsContestsService extends WebApiService {

    constructor() {
        super();

        this.post = super.post.bind(this);
        this.get = super.get.bind(this);
    }

    getTargets(targetPayload, successCallback, errorCallback) {
        this.post('/api/Targets/GetTargets/', targetPayload, successCallback, errorCallback);
    }

    saveTargets(targetPayload, successCallback, errorCallback) {
        this.post('/api/Targets/SaveTargets/', targetPayload, successCallback, errorCallback);
    }

    blastGoals(goalId, successCallback, errorCallback) {
        this.get('/api/GoalsContests/BlastGoals/' + goalId, successCallback, errorCallback);
    }

    goalsByClientAccount(goalPayload, successCallback, errorCallback) {
        this.post('/api/GoalsContests/GoalsByClientAccount/', goalPayload, successCallback, errorCallback);
    }

    goalsByLocation(locationId, successCallback, errorCallback) {
        this.get('/api/GoalsContests/GoalsByLocation/' + locationId, successCallback, errorCallback);
    }

    goalsByUser(userId, successCallback, errorCallback) {
        this.get('/api/GoalsContests/GoalsByUser/' + userId, successCallback, errorCallback);
    }

    saveGoal(goalData, successCallback, errorCallback) {
        this.post('/api/GoalsContests/SaveGoal/', goalData, successCallback, errorCallback);
    }

    deleteGoal(goalIds, successCallback, errorCallback) {
        this.post('/api/GoalsContests/DeleteGoals/', goalIds, successCallback, errorCallback);
    }

    goalLevels(clientAccountId, successCallback, errorCallback) {
        this.post('/api/GoalsContests/GoalLevels/' + clientAccountId, data, successCallback, errorCallback);
    }

    saveGoalLevels(goalLevelData, successCallback, errorCallback) {
        this.post('/api/GoalsContests/SaveGoalLevel', goalLevelData, successCallback, errorCallback);
    }

    deleteGoalLevels(goalLevelIds, successCallback, errorCallback) {
        this.post('/api/GoalsContests/DeleteGoalLevels', goalLevelIds, successCallback, errorCallback);
    }


    goalLevelValues(goalId, successCallback, errorCallback) {
        this.post('/api/GoalsContests/GoalLevels/' + goalId, data, successCallback, errorCallback);
    }

    saveGoalLevelValues(goalLevelData, successCallback, errorCallback) {
        this.post('/api/GoalsContests/SaveGoalLevel', goalLevelData, successCallback, errorCallback);
    }

    deleteGoalLevelValues(goalLevelValueIds, successCallback, errorCallback) {
        this.post('/api/GoalsContests/DeleteGoalLevelValues', goalLevelValueIds, successCallback, errorCallback);
    }

    setGoalArchive(goalArchiveItem, successCallback, errorCallback) {
        this.post('/api/GoalsContests/SetGoalArchive', goalArchiveItem, successCallback, errorCallback);
    }


    reportKPIs(clientAccountId, successCallback, errorCallback) {
        this.get('/api/GoalsContests/ReportKPIs/' + clientAccountId, successCallback, errorCallback);
    }

    goalUsers(clientAccountId, successCallback, errorCallback) {
        this.get('/api/GoalsContests/GoalUsers/' + clientAccountId, successCallback, errorCallback);
    }

    calendarDates(clientAccountId, successCallback, errorCallback) {
        this.get('/api/GoalsContests/CalendarDates/' + clientAccountId, successCallback, errorCallback);
    }

    contestsByContestId(contestId, successCallback, errorCallback) {
        this.get('/api/GoalsContests/ContestsByContestId/' + contestId, successCallback, errorCallback);
    }

    contestsByClientAccount(clientAccountId, successCallback, errorCallback) {
        this.get('/api/GoalsContests/ContestsByClientAccount/' + clientAccountId, successCallback, errorCallback);
    }

    contestsByLocation(locationId, successCallback, errorCallback) {
        this.get('/api/GoalsContests/ContestsByLocation/' + locationId, successCallback, errorCallback);
    }

    saveContest(contestData, successCallback, errorCallback) {
        this.post('/api/GoalsContests/SaveContest/', contestData, successCallback, errorCallback);
    }

    deleteContest(contestIds, successCallback, errorCallback) {
        this.post('/api/GoalsContests/DeleteContests/', contestIds, successCallback, errorCallback);
    }

    contestResultsByContestId(contestId, successCallback, errorCallback) {
        this.get('/api/GoalsContests/ContestResultsByContestId/' + contestId, successCallback, errorCallback);
    }

    saveContestResult(contestResultData, successCallback, errorCallback) {
        this.post('/api/GoalsContests/SaveContestResults/', contestResultData, successCallback, errorCallback);
    }

    setContestArchive(contestArchiveItem, successCallback, errorCallback) {
        this.post('/api/GoalsContests/SetContestArchive', contestArchiveItem, successCallback, errorCallback);
    }
}